import { useGoogleLogin } from "@react-oauth/google";
import axios from "axios";
import { Calendar } from "lucide-react";
import { useNavigate } from "react-router-dom";

export function MentorCalendarConnect() {
  const navigate = useNavigate();

  const login = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      console.log("Google login success:", tokenResponse);
      sessionStorage.setItem("googleAccessToken", tokenResponse.access_token);

      // Fetch user info
      try {
        const userInfoResponse = await axios.get(
          "https://www.googleapis.com/oauth2/v3/userinfo",
          {
            headers: { Authorization: `Bearer ${tokenResponse.access_token}` },
          }
        );
        sessionStorage.setItem("googleUserInfo", userInfoResponse.data);
        navigate("/mentor/calendar/availability");
      } catch (error) {
        console.error("Error fetching user info:", error);
      }
    },
    onError: (error) => {
      console.error("Login Failed:", error);
    },
    scope: "https://www.googleapis.com/auth/calendar.readonly",
  });

  return (
    <div className="mx-auto max-w-2xl px-4 py-8">
      <div className="rounded-lg border bg-white p-8 text-center shadow-sm">
        <div className="mb-8">
          <Calendar className="mx-auto mb-4 size-16 text-[#ffcc32]" />
          <h1 className="mb-4 text-2xl font-bold">Connect Your Calendar</h1>
          <p className="mb-6 text-gray-600">
            Connect your calendar to automatically find available time slots for
            mentorship sessions. We'll look for open spaces and slots marked as
          </p>
          <p>[VINCER] Landing Zone.</p>
        </div>

        <div className="flex flex-col items-center space-y-4">
          <div className="text-center">
            <button
              onClick={() => login()}
              className="flex gap-2 rounded-lg border border-slate-200 px-4 py-2 text-slate-700 transition duration-150 hover:border-slate-400 hover:text-slate-900 hover:shadow"
            >
              <img
                className="size-6"
                src="https://www.svgrepo.com/show/475656/google-color.svg"
                loading="lazy"
                alt="Google logo"
              />
              <span>Login with Google</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
